import { useEffect, useRef, useState } from 'react';
import { ResponseErrorPanel } from '@backstage/core-components';
import { ChatContainer, type ChatContainerRef } from '../ChatContainer';
import { useMcpServers } from '../../hooks';
import { useChatPageStyles } from '../ChatPage/new-chat-page.styles';
import type { MCPServer } from '../../types';

interface Message {
  id: string;
  text: string;
  isUser: boolean;
  timestamp: Date;
  tools?: string[];
  toolsUsed?: string[];
  toolResponses?: any[];
}

interface ExpertPanelProps {
  onConversationUpdated?: (conversationId: string) => void;
  onMcpServersChange?: (servers: MCPServer[]) => void;
  onPendingPromptChange?: (
    prompt: string | undefined,
    cancelRequest?: () => void,
  ) => void;
}

export const ExpertPanel = ({
  onConversationUpdated,
  onMcpServersChange,
  onPendingPromptChange,
}: ExpertPanelProps) => {
  const classes = useChatPageStyles();
  const chatContainerRef = useRef<ChatContainerRef>(null);
  const [messages, setMessages] = useState<Message[]>([]);
  const [conversationId, setConversationId] = useState<string>();
  const { mcpServers, error } = useMcpServers();

  useEffect(() => {
    onMcpServersChange?.(mcpServers);
  }, [mcpServers, onMcpServersChange]);

  const handleConversationUpdated = (updatedConversationId: string) => {
    setConversationId(updatedConversationId);
    onConversationUpdated?.(updatedConversationId);
  };

  return (
    <div className={classes.bodyContainer}>
      <div className={classes.chatContainer}>
        {error ? (
          <div className={classes.errorContainer}>
            <ResponseErrorPanel error={new Error(error)} defaultExpanded />
          </div>
        ) : (
          <ChatContainer
            ref={chatContainerRef}
            sidebarCollapsed
            mcpServers={mcpServers}
            messages={messages}
            onMessagesChange={setMessages}
            conversationId={conversationId}
            onConversationUpdated={handleConversationUpdated}
            onPendingPromptChange={onPendingPromptChange}
            hideRightPaneMargin
            compactInput
          />
        )}
      </div>
    </div>
  );
};
